var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputStyledText',{staticClass:"prose",attrs:{"value":_vm.buffer.info.content,"options":{},"bounds":_vm.bounds},on:{"blur":_vm.updateContent}})}
var staticRenderFns = []

export { render, staticRenderFns }